import React, { useState, useEffect } from 'react';
import {
  Container,
  CssBaseline,
  Tab,
  Tabs,
  AppBar,
  Toolbar,
  Button,
  Link,
  Typography,
  IconButton,
  Drawer,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { fetchColleges } from '../../redux/actions/collegesActions';
import { logout } from '../../services/authService';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import CollegesTabContent from '../colleges-tab-content';
import FilesTabContent from '../files-tab-content';
import LegalInformation from '../legal-informations-tab';
import { ReactComponent as Logo } from '../../assets/unimates_logo_paysage.svg';
import ContactTab from '../contact';

function Dashboard() {
  const [currentTab, setCurrentTab] = useState('colleges');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const colleges = useSelector((state) => state.colleges.data);
  const loading = useSelector((state) => state.colleges.loading);
  const error = useSelector((state) => state.colleges.error);

  useEffect(() => {
    dispatch(fetchColleges());
  }, [dispatch]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
    if (isSidebarOpen) {
      setIsSidebarOpen(false);
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div style={{ width: '100%', display: 'flex' }}>
      <Drawer
        anchor="left"
        open={isSidebarOpen}
        onClose={toggleSidebar}
        variant="temporary"
        ModalProps={{ keepMounted: true }}
      >
        <div>
          <IconButton
            onClick={toggleSidebar}
            style={{ marginLeft: 'auto' }}
          >
            <CloseIcon />
          </IconButton>
          <Tabs
            orientation="vertical"
            value={currentTab}
            onChange={handleTabChange}
            textColor="inherit"
          >
            <Tab label="Collèges" value="colleges" />
            <Tab label="Fiches" value="files" />
            <Tab label="Information légale" value="LegalInformation" />
            <Tab label="Boîte de réception" value="contact" />
            <Button
              component={Link}
              color="inherit"
              onClick={handleLogout}
            >
              Se déconnecter
            </Button>
          </Tabs>
        </div>
      </Drawer>
      <div  style={{ width: '100%' }}>
        <CssBaseline />
        <AppBar
          position="static"
          style={{ backgroundColor: '#FC6258', width: '100%' }}
        >
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={toggleSidebar}
              sx={{ display: { sm: 'none', xs: 'block' } }}
            >
              <MenuIcon />
            </IconButton>
            <Logo style={{ width: '140px', height: 'auto' }} />

            <div style={{ marginLeft: 'auto' }}>
              <Tabs
                value={currentTab}
                onChange={handleTabChange}
                TabIndicatorProps={{ style: { backgroundColor: 'white' } }}
                textColor="inherit"
                sx={{ display: { xs: 'none', sm: 'block' } }}
              >
                <Tab label="Collèges" value="colleges" />
                <Tab label="Fiches" value="files" />
                <Tab label="Information légale" value="LegalInformation" />
                <Tab label="Boîte de réception" value="contact" />
                <Button
                  component={Link}
                  color="inherit"
                  onClick={handleLogout}
                >
                  Se déconnecter
                </Button>
              </Tabs>
            </div>
          </Toolbar>
        </AppBar>

        {currentTab === 'colleges' && <CollegesTabContent colleges={colleges} />}
        {currentTab === 'files' && <FilesTabContent />}
        {currentTab === 'LegalInformation' && <LegalInformation />}
        {currentTab === 'contact' && <ContactTab />}
      </div>
      {loading && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
    </div>
  );
}

export default Dashboard;
